import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import moment from 'moment';
import { customerResource } from '@/views/system/customerManage/request';
import { policyNoResource, personnelDetailExport, personnelDetailsRecordPrompt, endorsementCreate, checkAndPreviewEndorsement, endorsementExportSend } from './request';
import { downloadFileFun } from '@/utils/public';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    customerId: {}
  },
  watch: {
    async visible(newV) {
      if (newV) {
        const res = await customerResource({});
        this.customerList2 = res;
        this.policyNoResourceFn();
        this.form.policyNo = undefined;
        this.form.time = [];
        this.form.customerId = this.customerId;
        this.loading = false;
        this.exportLoading = false;
      }
      this.showVisible = newV;
    },
    customerId(newV) {
      this.form.customerId = newV;
    }
  },
  data() {
    return {
      form: {
        time: [],
        customerId: undefined,
        policyNo: undefined
      },
      showVisible: false,
      customerList2: [],
      policyNoList: [],
      tipVisible: false,
      importStatus: '',
      requestInfo: {},
      count: 0,
      loading: false,
      exportLoading: false
    };
  },
  methods: {
    handleMenuClick(type) {
      if (!this.form.policyNo) {
        return this.$message.warn(this.$t('请选择') + this.$t('保单号'));
      }
      if (!this.form.time.length) {
        return this.$message.warn(this.$t('请选择') + this.$t('日期范围'));
      }
      let params = {
        customerId: this.form.customerId,
        createAt: moment(this.form.time[0]).format('YYYY-MM-DD'),
        endAt: moment(this.form.time[1]).format('YYYY-MM-DD'),
        policyNo: this.form.policyNo,
        anchorPoint: type.key === 'create' ? 'POLICY_GENERATE' : 'POLICY_GENERATE_SEND'
      };
      this.loading = true;
      this.tipVisible = true;
      this.$set(this.requestInfo, 'type', type.key);
      let currentCount = this.count++;
      let loadingTip = type.key === 'create' ? '批单生成中,请耐心等待 不要退出该页面' : '批单生成中,请耐心等待 不要重复点击发送';
      this.$set(this.requestInfo, 'loadingTip', loadingTip);
      checkAndPreviewEndorsement(params).then(res => {
        if (res && res.checkStatus && type.key === 'createAndSend' && this.count - 1 === currentCount) {
          this.createAndSend(params, currentCount);
        } else if (res && res.checkStatus && type.key === 'create' && this.count - 1 === currentCount) {
          this.createEndorsementDownload(params, currentCount);
        } else if (this.count - 1 === currentCount) {
          this.importStatus = 'ERROR';
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
      });
      return;
    },
    tipChange() {
      if (this.requestInfo.type === 'createAndSend') {
        window.open(this.requestInfo.url, '_self');
      } else {
        this.tipVisible = false;
      }
    },
    createAndSend(params, currentCount) {
      endorsementExportSend(params).then(res => {
        this.loading = false;
        if (res && res.fileTempUrl && this.count - 1 === currentCount) {
          this.importStatus = 'SUCCESS';
          this.$set(this.requestInfo, 'url', res.fileTempUrl);
        } else if (this.count - 1 === currentCount) {
          this.importStatus = 'ERROR';
          this.$message.error(res.data && res.data.message);
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
      });
    },
    createEndorsementDownload(params, currentCount) {
      endorsementCreate(params).then(res => {
        this.loading = false;
        if (res && res.data && res.status === 200 && this.count - 1 === currentCount) {
          this.importStatus = 'SUCCESS';
          let fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace(/^\"|\"$/g, '').replace(/utf-8''/, ''));
          downloadFileFun(res.data, 'application/msword', fileName);
        } else if (this.count - 1 === currentCount) {
          this.importStatus = 'ERROR';
          this.$message.error(res.data && res.data.message);
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
      });
    },
    preview() {
      if (!this.form.policyNo) {
        return this.$message.warn(this.$t('请选择') + this.$t('保单号'));
      }
      if (!this.form.time.length) {
        return this.$message.warn(this.$t('请选择') + this.$t('日期范围'));
      }
      let params = {
        customerId: this.form.customerId,
        createAt: moment(this.form.time[0]).format('YYYY-MM-DD'),
        endAt: moment(this.form.time[1]).format('YYYY-MM-DD'),
        policyNo: this.form.policyNo,
        anchorPoint: 'POLICY_PREVIEW'
      };
      let currentCount = this.count++;
      this.loading = true;
      this.tipVisible = true;
      this.$set(this.requestInfo, 'type', 'preview');
      this.$set(this.requestInfo, 'loadingTip', '批单生成中,请耐心等待 不要退出该页面');
      checkAndPreviewEndorsement(params).then(res => {
        this.loading = false;
        if (res && res.fileTempUrl && this.count - 1 === currentCount) {
          this.importStatus = 'SUCCESS';
          window.open(res.fileTempUrl);
          // window.location.href = res.fileTempUrl;
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
      });
    },
    disabledDate(current) {
      return current && current > moment().endOf('day') || current && current < moment().subtract(1, 'months').subtract(1, 'day');
    },
    async onExport() {
      if (!this.form.policyNo) {
        return this.$message.warn(this.$t('请选择') + this.$t('保单号'));
      }
      if (!this.form.time.length) {
        return this.$message.warn(this.$t('请选择') + this.$t('日期范围'));
      }
      let obj = {
        customerId: this.form.customerId,
        policyNo: this.form.policyNo,
        createAt: moment(this.form.time[0]).format('YYYY-MM-DD'),
        endAt: moment(this.form.time[1]).format('YYYY-MM-DD')
      };
      this.exportLoading = true;
      const prompt = await personnelDetailsRecordPrompt(obj).finally(() => {
        this.exportLoading = false;
      });
      if (prompt) {
        var _this$customerList2$f;
        this.exportLoading = true;
        const res = await personnelDetailExport(obj).finally(() => {
          this.exportLoading = false;
        });
        let name = (_this$customerList2$f = this.customerList2.find(i => i.id == this.form.customerId)) === null || _this$customerList2$f === void 0 ? void 0 : _this$customerList2$f.name;
        downloadFileFun(res, 'application/vnd.ms-excel', name + obj.createAt + this.$t('增减员明细') + '.xlsx');
      }
    },
    changeCustomerId() {
      this.form.policyNo = undefined;
      this.form.time = [];
      this.policyNoResourceFn();
    },
    async policyNoResourceFn() {
      const res = await policyNoResource({
        customerId: this.form.customerId
      });
      this.policyNoList = res;
    },
    tip() {
      return this.$message.info(this.$t('此功能在内测阶段，敬请期待~'));
    },
    close() {
      this.$emit('cancel');
    }
  }
};